import { render, staticRenderFns } from "./ReactiveChangePassword.vue?vue&type=template&id=81c969d4&"
import script from "@/scripts/auth/reactiveChangePassword.js?vue&type=script&lang=js&"
export * from "@/scripts/auth/reactiveChangePassword.js?vue&type=script&lang=js&"
import style0 from "./ReactiveChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports